import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IListNodeNavigationResponse } from '@types'

const FIND_FEATURED_QUERY = gql`
  query FindFeatured {
    findFeatured {
      type
      payload {
        ... on NodeNavigationListResponse {
          nodeNavigationList {
            details {
              nature {
                purpose
                code
              }
            }
            id
            title
          }
        }
      }
    }
  }
`

export const useFeaturedQuery = () => {
  const query = useQuery<IListNodeNavigationResponse>(FIND_FEATURED_QUERY, {
    fetchPolicy: 'cache-first'
  })
  return query
}
